/*
  Native Gardeners accessibility enhancements, round 5. Added 2026-10-19.
  Runs after a11y-enhancements.js (items 1-17) and a11y-round4.js (items 18-38).
  Every change is additive: nothing here removes theme markup or behaviour.

  40. Pause/Play control for hero background videos (WCAG 2.2.2); videos pause by default when the
      visitor's system asks for reduced motion.
  41. Collection pages: announce the result of applying or removing a filter through the existing
      #a11y-status live region, and show a visible results count (WCAG 4.1.3).
  42. Filter drawer: each filter group's checkboxes are exposed as a named group (WCAG 1.3.1).
  43. Form fields get autocomplete tokens where the purpose is known (WCAG 1.3.5).
  44. Third-party iframes: the contact-form embed is titled "Contact form"; background-video frames are
      marked decorative (WCAG 4.1.2 / 1.1.1).
  45. Links that open a new window say so to assistive technology (WCAG G201).
  46. Blog index: "Continue reading" links carry the post title for screen readers (WCAG 2.4.4).
*/
(function () {
  'use strict';

  var hidden = function (text) {
    var s = document.createElement('span');
    s.className = 'visually-hidden';
    s.textContent = text;
    return s;
  };

  var announce = function (message) {
    var region = document.getElementById('a11y-status');
    if (!region) {
      region = document.createElement('div');
      region.id = 'a11y-status';
      region.className = 'visually-hidden';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 80);
  };

  /* 40. Hero background video controls. */
  function heroVideoControls() {
    var sections = document.querySelectorAll('[data-section-type="video-section"]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.querySelector('.a11y-video-toggle')) { return; }

      var paused = false;
      var holdTimer = null;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'a11y-video-toggle';
      button.setAttribute('aria-pressed', 'false');
      button.textContent = 'Pause video';
      button.hidden = true;

      var frame = function () {
        return section.querySelector('iframe, video');
      };

      var send = function (command) {
        var f = frame();
        if (!f) { return; }
        if (f.tagName === 'VIDEO') {
          if (command === 'pauseVideo') { f.pause(); } else { f.play(); }
          return;
        }
        try {
          f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command, args: [] }), '*');
        } catch (e) { /* frame not ready */ }
      };

      var setPaused = function (state) {
        paused = state;
        button.setAttribute('aria-pressed', state ? 'true' : 'false');
        button.textContent = state ? 'Play video' : 'Pause video';
        if (holdTimer) { window.clearInterval(holdTimer); holdTimer = null; }
        if (state) {
          send('pauseVideo');
          /* The theme restarts background video when it scrolls into view; keep it paused until the visitor presses Play. */
          holdTimer = window.setInterval(function () { send('pauseVideo'); }, 1500);
        } else {
          send('playVideo');
        }
      };

      button.addEventListener('click', function () { setPaused(!paused); });
      section.appendChild(button);

      /* Show the control once the video frame exists. The theme creates the player only when the section
         scrolls into view (and not while a modal is open), so watch the section rather than polling. */
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var revealed = false;
      var reveal = function () {
        if (revealed || !frame()) { return; }
        revealed = true;
        button.hidden = false;
        if (reduce) { window.setTimeout(function () { setPaused(true); }, 1200); }
      };
      reveal();
      if (!revealed) {
        var watcher = new MutationObserver(function () {
          reveal();
          if (revealed) { watcher.disconnect(); }
        });
        watcher.observe(section, { childList: true, subtree: true });
      }
    });
  }

  /* 41. Collection filter results. */
  function collectionResults() {
    var result = document.getElementById('CollectionAjaxResult');
    var filterBar = document.querySelector('#CollectionSection .collection-filter');
    if (!result || !filterBar) { return; }

    var count = document.getElementById('a11y-results-count');
    if (!count) {
      count = document.createElement('p');
      count.id = 'a11y-results-count';
      count.className = 'a11y-results-count';
      filterBar.insertAdjacentElement('afterend', count);
    }

    var describe = function () {
      var n = result.querySelectorAll('.grid-product').length;
      var pages = document.querySelector('.pagination');
      var text;
      if (n === 0) {
        text = 'No products match the selected filters.';
      } else {
        text = 'Showing ' + n + (n === 1 ? ' product' : ' products') + (pages ? ' on this page' : '') + '.';
      }
      return text;
    };

    count.textContent = describe();

    var pending = false;
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (t && t.closest && t.closest('.filter-form, #FilterDrawer, .collection-filter')) { pending = true; }
    }, true);
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (t && t.closest && t.closest('.tag--remove, .filter-form a, #FilterDrawer a')) { pending = true; }
    }, true);

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) { window.clearTimeout(timer); }
      timer = window.setTimeout(function () {
        var text = describe();
        count.textContent = text;
        if (pending) {
          pending = false;
          announce('Filters updated. ' + text);
        }
        filterGroups();
      }, 350);
    });
    observer.observe(result, { childList: true, subtree: true });
  }

  /* 42. Named filter groups. */
  function filterGroups() {
    var groups = document.querySelectorAll('.collection-sidebar__group');
    Array.prototype.forEach.call(groups, function (group) {
      var trigger = group.querySelector('button.collapsible-trigger');
      var content = group.querySelector('.collapsible-content');
      if (!trigger || !content) { return; }
      if (!trigger.id) { trigger.id = (content.id || 'FilterGroup-' + Math.random().toString(36).slice(2, 8)) + '-label'; }
      if (content.getAttribute('role') !== 'group') { content.setAttribute('role', 'group'); }
      if (content.getAttribute('aria-labelledby') !== trigger.id) { content.setAttribute('aria-labelledby', trigger.id); }
    });
  }

  /* 42b. The mobile navigation drawer is a modal panel; expose it as a named dialog (the Filter drawer
     gets the same in snippets/sidebar-drawer.liquid). */
  function drawerSemantics() {
    var nav = document.getElementById('NavDrawer');
    if (nav && nav.getAttribute('role') !== 'dialog') {
      nav.setAttribute('role', 'dialog');
      nav.setAttribute('aria-modal', 'true');
      nav.setAttribute('aria-label', 'Site navigation');
    }
  }

  /* 43. Autocomplete tokens. */
  function autocompleteTokens() {
    var map = {
      'comment[author]': 'name',
      'comment[email]': 'email',
      'contact[name]': 'name',
      'contact[email]': 'email',
      'contact[phone]': 'tel',
      'customer[email]': 'email',
      'customer[first_name]': 'given-name',
      'customer[last_name]': 'family-name'
    };
    Object.keys(map).forEach(function (name) {
      var fields = document.querySelectorAll('input[name="' + name + '"], textarea[name="' + name + '"]');
      Array.prototype.forEach.call(fields, function (field) {
        if (!field.getAttribute('autocomplete') || field.getAttribute('autocomplete') === 'off') {
          field.setAttribute('autocomplete', map[name]);
        }
      });
    });
  }

  /* 44. Iframe titles and decorative background video frames. */
  function iframeTitles() {
    var frames = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(frames, function (frame) {
      var src = frame.getAttribute('src') || '';
      if (/pifyapp\.com/.test(src) && frame.title !== 'Contact form') {
        frame.title = 'Contact form';
      }
      if (frame.closest('[data-section-type="video-section"]') && frame.getAttribute('aria-hidden') !== 'true') {
        frame.setAttribute('aria-hidden', 'true');
        frame.setAttribute('tabindex', '-1');
      }
    });
  }

  /* 45. Links that open a new window. Links with no accessible name of their own (an image link whose
     image has no alt text) are left alone: that is a content defect to fix, not to paper over. */
  function newWindowLinks() {
    var links = document.querySelectorAll('a[target="_blank"]:not([data-a11y-newwin])');
    Array.prototype.forEach.call(links, function (link) {
      var label = link.getAttribute('aria-label');
      var img = link.querySelector('img');
      var svgTitle = link.querySelector('svg title');
      var ownName = ((label || '') + ' ' + (link.textContent || '') + ' ' + (img ? img.alt || '' : '') + ' ' + (svgTitle ? svgTitle.textContent : '')).trim();
      if (!ownName) { return; }
      link.setAttribute('data-a11y-newwin', '1');
      var text = (label || '') + ' ' + (link.textContent || '');
      if (/new (tab|window)/i.test(text)) { return; }
      if (label) {
        link.setAttribute('aria-label', label + ' (opens in a new window)');
      } else {
        link.appendChild(hidden(' (opens in a new window)'));
      }
    });
  }

  /* 46. "Continue reading" links on the blog index. */
  function continueReadingLinks() {
    var links = document.querySelectorAll('a:not([data-a11y-context])');
    Array.prototype.forEach.call(links, function (link) {
      if ((link.textContent || '').trim().toLowerCase() !== 'continue reading') { return; }
      link.setAttribute('data-a11y-context', '1');
      var item = link.closest('.article-listing, .blog-listing__item, article, .grid__item, li');
      var heading = item && item.querySelector('h1, h2, h3, h4, .article__title');
      var title = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
      if (title) { link.appendChild(hidden(': ' + title)); }
    });
  }

  function runAll() {
    filterGroups();
    drawerSemantics();
    autocompleteTokens();
    iframeTitles();
    newWindowLinks();
    continueReadingLinks();
  }

  function init() {
    heroVideoControls();
    collectionResults();
    runAll();

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) { window.clearTimeout(timer); }
      timer = window.setTimeout(runAll, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
